var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54227 10.7866H10.5744C10.8257 10.7866 10.9281 10.9633 10.8024 11.1812L7.82796 16.337C7.70291 16.5537 7.49827 16.555 7.3726 16.337L4.39811 11.1812C4.27306 10.9646 4.37435 10.7866 4.62603 10.7866H5.65829C5.90966 10.7866 6.11397 10.5813 6.11397 10.3279V8.04399C6.11397 7.79055 6.31893 7.58546 6.5719 7.58546H8.62846C8.88222 7.58546 9.08654 7.79073 9.08654 8.04399V10.3279C9.08654 10.5815 9.29054 10.7866 9.54222 10.7866H9.54227ZM1.31391 6.21344H0.281811C0.0304446 6.21344 -0.0719564 6.03671 0.0537311 5.81884L3.02822 0.663047C3.15327 0.446289 3.3579 0.445015 3.48358 0.663047L6.45807 5.81884C6.58311 6.03544 6.48183 6.21344 6.23015 6.21344H5.19789C4.94652 6.21344 4.74221 6.41871 4.74221 6.67214V8.95601C4.74221 9.20945 4.53725 9.41454 4.28428 9.41454H2.22772C1.97396 9.41454 1.76963 9.20927 1.76963 8.95601V6.67214C1.76963 6.41854 1.56564 6.21344 1.31395 6.21344H1.31391Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/doubleArrow.239b7afbe819bdcd19497023ab6ac982.svg";
export { ForwardRef as ReactComponent };